import useFetch from '@hooks/useFetch';

const useSessionMetaDataInfo = (goalUID) => {
  const key = `v1/live_interaction/learner/sessions_meta/?goal_uid=${goalUID}`;
  const { data = {}, ...rest } = useFetch(
    goalUID ? key : null,
    {},
    {
      revalidateOnMount: true
    }
  );

  return { sessionMetaData: data, ...rest };
};

export default useSessionMetaDataInfo;
